import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SmartcoreNav.css';

const IconHome = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10.5L12 3l9 7.5" />
    <path d="M5 9.5V20h14V9.5" />
    <path d="M9.5 20v-6h5v6" />
  </svg>
);

const IconSystems = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="7" y="7" width="10" height="10" rx="2" />
    <circle cx="12" cy="12" r="1.6" />
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.5 5.5l1.6 1.6M16.9 16.9l1.6 1.6M18.5 5.5l-1.6 1.6M7.1 16.9l-1.6 1.6" />
  </svg>
);

const IconNetwork = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="5" r="2.4" />
    <circle cx="5" cy="18" r="2.4" />
    <circle cx="19" cy="18" r="2.4" />
    <path d="M12 7.4v3.6M10.4 12.6l-3.2 3.2M13.6 12.6l3.2 3.2" />
  </svg>
);

const IconAnalytics = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20V4M20 20H4" />
    <path d="M7 16l3.5-4 3 2.5L20 7" />
  </svg>
);

const SmartcoreNav = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Home', Icon: IconHome },
    { path: '/units', label: 'AI Systems', Icon: IconSystems },
    { path: '/team', label: 'Network', Icon: IconNetwork },
    { path: '/record', label: 'Analytics', Icon: IconAnalytics },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="smartcore-nav">
      <div className="smartcore-nav-container">
        {navItems.map((item) => {
          const { Icon } = item;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`smartcore-nav-item ${isActive(item.path) ? 'active' : ''}`}
            >
              <span className="nav-item-icon"><Icon /></span>
              <span className="nav-item-label">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default SmartcoreNav;
